import { Injectable } from "@angular/core";
import { catchError, map, Observable, of, switchMap, throwError } from "rxjs";
import { ConfigService } from "../config/config.service";
import { KeywordsService } from "../lobby/keywords.service";


interface Lobby {
    name: string;
    placement?: string;
}

@Injectable({ providedIn: 'root' })

export class SwimLanesService {

    constructor(
        private readonly config: ConfigService,
        private readonly keywordsService: KeywordsService,
    ) {

    }

    public getSwimLanesData(): Observable<any> {
        const filter = this.config?.getConfig()?.FEATURE_LOBBYLIST_FILTER ?? 'casino';
        return this.keywordsService.getLobbies().pipe(
            map((lobbies: Lobby[]) => {
                return lobbies.filter(lobby =>
                    lobby.placement === 'MAIN' && new RegExp(filter, 'i').test(lobby.name)
                );
            }),
            switchMap((filteredLobbies: Lobby[]) => {
                if (filteredLobbies.length === 0) {
                    return throwError(() => new Error('No matching lobbies found'));
                }
                const lobbyName = filteredLobbies[0].name;
                return this.keywordsService.getKeywordsAndGames(lobbyName);
            }),
            catchError((error) => {
                console.error('Error fetching swim lanes data', error);
                return of(null);
            })
        );
    }
}